/* Nashie best sellers — range tabs, pop-up size picker, quick add.
   Vanilla JS, no dependencies. Safe to load on every page. */
(function () {
  function cartUrl(path) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root + path;
  }

  function postJSON(path, body) {
    return fetch(cartUrl(path), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  // Cards holding a line in the cart. The button only says "Added" while that
  // line is really there, so taking it out in the drawer, on the cart page or
  // in another tab puts the card back to Add to cart on its own.
  var live = [];
  var pending = null;

  function syncCart() {
    if (!live.length) return;
    fetch(cartUrl('cart.js'), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var qty = {};
        (cart.items || []).forEach(function (i) { qty[i.key] = i.quantity; });
        live.slice().forEach(function (fn) { fn(qty); });
      })
      .catch(function () {});
  }

  function scheduleSync() {
    clearTimeout(pending);
    pending = setTimeout(syncCart, 450);
  }

  // Themes disagree on how a cart change gets broadcast and on what their
  // drawer is called, so fire every common name and try every common element.
  // Whichever one this theme happens to listen for does the work and the rest
  // are ignored, which is what lets the section drop into a theme it has never
  // met and still update the cart bubble.
  var CART_EVENTS = ['cart:refresh', 'cart:build', 'cart:change', 'cart:updated', 'ajaxCart.afterCartLoad'];
  var DRAWERS = 'cart-drawer, cart-notification, #CartDrawer, #cart-drawer';

  function announce() {
    CART_EVENTS.forEach(function (name) {
      document.documentElement.dispatchEvent(new CustomEvent(name, { bubbles: true }));
      document.dispatchEvent(new CustomEvent(name));
    });
    var drawer = document.querySelector(DRAWERS);
    if (drawer && typeof drawer.open === 'function') { drawer.open(); }
  }

  CART_EVENTS.concat(['cart:update']).forEach(function (name) {
    document.addEventListener(name, scheduleSync);
  });
  // No theme event is guaranteed when someone empties a drawer, and a removal
  // is always a click somewhere, so any click is a reason to re-check. It is
  // free until a card actually has something in the cart, and debounced.
  document.addEventListener('click', scheduleSync);
  document.addEventListener('visibilitychange', function () { if (!document.hidden) scheduleSync(); });
  window.addEventListener('pageshow', scheduleSync);

  function initSection(root) {
    if (root.dataset.nbsReady) return;
    root.dataset.nbsReady = '1';

    // Range tabs
    var tabs = root.querySelectorAll('[data-nbs-tab]');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var id = tab.getAttribute('data-nbs-tab');
        tabs.forEach(function (t) { t.setAttribute('aria-selected', t === tab ? 'true' : 'false'); });
        root.querySelectorAll('[data-nbs-pane]').forEach(function (pane) {
          pane.hidden = pane.getAttribute('data-nbs-pane') !== id;
        });
      });
    });

    // Cards
    root.querySelectorAll('[data-nbs-card]').forEach(function (card) {
      var picker = card.querySelector('[data-nbs-picker]');
      var cta = card.querySelector('[data-nbs-cta]');
      var change = card.querySelector('[data-nbs-change]');
      if (!picker || !cta) return;

      var state = { id: null, label: null, price: null };
      var busy = false;
      // The line this card last put in the cart, so Change can take it back out.
      var line = { key: null, qty: 0 };
      // Set only while the picker is open because they pressed Change.
      var correcting = false;

      function paint() {
        // Driven by the cart, not by what they clicked, so the button can never
        // claim something is in there when it isn't.
        if (line.key) {
          picker.classList.add('has-size');
          cta.classList.add('is-ready');
          cta.textContent = cta.dataset.addedLabel;
          change.textContent = 'Size ' + state.label + ' · Change';
        } else {
          picker.classList.remove('has-size');
          cta.classList.remove('is-ready');
          cta.textContent = cta.dataset.selectLabel;
        }
      }

      function open() {
        // On mobile the row is a sideways scroller that clips at its own edge,
        // and the popover is wider than a card. Open one on a card sitting half
        // off-screen and the right column of sizes is cut off, so slide the
        // card to the gutter first and it has room. The last card can't be
        // moved left any further, which is why CSS flips that one instead.
        var grid = card.parentElement;
        if (grid && grid.scrollWidth > grid.clientWidth + 1) {
          var delta = card.getBoundingClientRect().left - grid.getBoundingClientRect().left - 16;
          if (Math.abs(delta) > 2) {
            try { grid.scrollBy({ left: delta, behavior: 'smooth' }); }
            catch (e) { grid.scrollLeft += delta; }
          }
        }
        picker.classList.add('is-open');
      }
      function close() { picker.classList.remove('is-open'); }

      function watch(qty) {
        if (busy || !line.key) return;
        if (!(line.key in qty)) { forget(); return; }
        line.qty = qty[line.key];
      }

      function remember() {
        if (live.indexOf(watch) === -1) live.push(watch);
      }

      function forget() {
        var i = live.indexOf(watch);
        if (i > -1) live.splice(i, 1);
        line = { key: null, qty: 0 };
        state = { id: null, label: null, price: null };
        card.querySelectorAll('.nbs__size').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
        paint();
      }

      function bail() {
        busy = false;
        cta.disabled = false;
        window.location.href = card.getAttribute('data-product-url');
      }

      function add(replace) {
        // Guarded, because picking a size now fires this on its own: a double
        // tap, or a tap while the first request is still out, must not put two
        // of the same shirt in the cart.
        if (!state.id || busy) return;
        busy = true;
        cta.disabled = true;

        // Coming through Change means they are correcting the size, not buying
        // a second shirt, so one of the old line comes back out first. One, not
        // the whole line: someone who pressed Add twice for two mediums and
        // then swapped to large should keep the medium they still want. A
        // removal that fails (cart emptied in another tab) can't block the add.
        var first = replace && line.key
          ? postJSON('cart/change.js', { id: line.key, quantity: Math.max(0, line.qty - 1) }).catch(function () {})
          : Promise.resolve();

        first
          .then(function () {
            return postJSON('cart/add.js', { items: [{ id: Number(state.id), quantity: 1 }] });
          })
          .then(function (data) {
            // cart/add.js answers 200-shaped JSON either way; a rejected line
            // (sold out, limit reached) comes back carrying a status. Sending
            // them to the product page beats a silent no-op they can't see.
            if (!data || data.status) { bail(); return; }
            var item = (data.items && data.items[0]) || data;
            line = { key: item.key || null, qty: item.quantity || 1 };
            remember();
            paint();
            announce();
            setTimeout(function () { busy = false; cta.disabled = false; }, 900);
          })
          .catch(bail);
      }

      card.querySelectorAll('.nbs__size').forEach(function (btn) {
        btn.addEventListener('click', function () {
          card.querySelectorAll('.nbs__size').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
          btn.setAttribute('aria-pressed', 'true');
          state = {
            id: btn.getAttribute('data-variant-id'),
            label: btn.textContent.trim(),
            price: btn.getAttribute('data-variant-price')
          };
          var replace = correcting;
          correcting = false;
          close();
          // The size is the last decision there is, so it is the buy. Making
          // them find the button again after choosing was a step for nothing.
          add(replace);
        });
      });

      change.addEventListener('click', function () {
        correcting = true;
        open();
      });

      cta.addEventListener('click', function () {
        if (!state.id) {
          correcting = false;
          if (picker.classList.contains('is-open')) { close(); } else { open(); }
          return;
        }
        add(false);
      });

      document.addEventListener('click', function (e) {
        if (!picker.contains(e.target)) { correcting = false; close(); }
      });

      paint();
    });
  }

  function boot() { document.querySelectorAll('[data-nbs]').forEach(initSection); }

  document.addEventListener('DOMContentLoaded', boot);
  boot();
  // Theme editor: re-init when the section is re-rendered
  document.addEventListener('shopify:section:load', boot);
})();
